import { GoogleOAuthProvider } from '@react-oauth/google';
import React, { useEffect } from 'react';
import { goToAdminExplore } from 'router/go-to';
import { AuthRouter } from 'features/authentication/router/auth-router';
import { redirectToDashboard } from 'store/auth/utils/utils';
import { useRouteParam } from 'hooks/use-query/use-query';
import { getLoginCookie } from 'utils/cookies/utils';
import { GOOGLE_CLIENT_ID } from './utils/constants';
import { useAuthActions } from 'store/auth/use-auth-actions';

export const AuthPage = () => {
    const nextUrlQueryParam = useRouteParam('next_url');
    const { fetchAnonymousPermissions } = useAuthActions();

    useEffect(() => {
        if (getLoginCookie()) {
            nextUrlQueryParam ? redirectToDashboard(nextUrlQueryParam) : goToAdminExplore();
        } else {
            fetchAnonymousPermissions();
        }
    }, [fetchAnonymousPermissions, nextUrlQueryParam]);

    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <AuthRouter />
        </GoogleOAuthProvider>
    );
};

export default AuthPage;
